import 'regenerator-runtime/runtime';
import Hammer from 'lbs-pi-hammer/src/index';
import AppContainer from './AppContainer.vue';
import { makeApp } from 'core';
import { initModules } from 'modules';
import { initApp } from './init-app';

initApp(Hammer, AppContainer, makeApp, initModules);
